import { ToggleButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppEditIcon } from "../../Icon/AppEditIcon";
import { AppToggleButton } from "../AppToggleButton";

export const EditToggleButton = (props: ToggleButtonProps) => (
    <AppToggleButton
        {...props}
        sx={{ padding: props.size === "small" ? "4px 8px" : "7px 16px", textTransform: "none", borderRadius: "8px", borderWidth: "0" }}
        tooltip={props.selected ? Translations.ChangeToReadMode : Translations.ChangeToEditMode}
    >
        <AppEditIcon sx={{ marginRight: "4px" }} fontSize={props.size}/>{props.selected ? Translations.EditMode : Translations.ReadMode}
    </AppToggleButton>
);
